import { Grid } from '@mui/material';

import { FORTA_WHITE } from '../../utils/colors';
import { FHSkeletonLoader } from '../../components/base';

function AdminRowLoader() {
  return (
    <Grid
      container
      p={2}
      alignItems="center"
      sx={{ backgroundColor: FORTA_WHITE, borderRadius: '10px', mb: 2 }}
      gap={3}
    >
      <Grid item xs={2}>
        <FHSkeletonLoader />
      </Grid>
      <Grid item xs={2}>
        <FHSkeletonLoader />
      </Grid>
      <Grid item xs={2}>
        <FHSkeletonLoader />
      </Grid>
      <Grid item xs={2}>
        <FHSkeletonLoader />
      </Grid>
      <Grid item xs={1}>
        <FHSkeletonLoader />
      </Grid>
      <Grid item xs={1}>
        <FHSkeletonLoader />
      </Grid>
    </Grid>
  );
}

export default AdminRowLoader;
